<div #formRow class="form-group d-flex flex-column" [ngClass]="{ 'mb-0': noMarginBottom }">
  @if (label?.length) {
    <label class="d-flex justify-content-between">
      <span class="inline-flex-gap-5 align-items-center">
        {{ label | translate }}
        @if (tooltipLabel?.length) {
          <info-tooltip [label]="tooltipLabel" [icon]="tooltipIcon"></info-tooltip>
        }
      </span>
      @if (required) {
        <label class="float-right required"> ({{ 'required' | translate }}) </label>
      }
    </label>
  }
  <div class="input-group" style="width: -webkit-fill-available">
    @if (icon?.length) {
      <div class="input-group-prepend"></div>
    }
    @if (inputDisabled && !bindToObject) {
      <select
        class="form-control"
        [class]="classesString"
        [ngModel]="model"
        [ngModelOptions]="{ standalone: true }"
        [attr.data-cy]="dataCyAttribute"
        disabled
      >
        @for (opt of options; track opt) {
          <option value="{{ opt?.[optionKey] ?? opt }}">
            {{ opt?.[optionKey] ?? (translationPrefix ?? '') + opt | translate }}
          </option>
        }
      </select>
    }
    @if (!inputDisabled && !bindToObject) {
      <select
        [ngClass]="{
          'is-invalid': requiredCssClass
        }"
        class="form-control"
        [attr.required]="required"
        [class]="classesString"
        [ngModel]="model"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onNgModelChange($event)"
        (keyup)="onInputKeyPress($event)"
        (change)="onInputValueChange($event)"
        (blur)="onChange($event)"
        [attr.data-track-category]="trackCategory"
        [attr.data-track-action]="trackAction"
        [attr.data-cy]="dataCyAttribute"
        [disabled]="isSelectDisabled"
      >
        @for (opt of options; track opt) {
          <option value="{{ opt?.[optionKey] ?? opt }}">
            {{ opt?.[optionKeyText] ?? (translationPrefix ?? '') + opt | translate }}
          </option>
        }
      </select>
    }
    @if (bindToObject) {
      <select
        class="form-control"
        [compareWith]="compareWithFn"
        [ngModel]="model"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onNgModelChange($event)"
        (blur)="onChange($event)"
        [attr.data-cy]="dataCyAttribute"
      >
        @for (opt of options; track opt) {
          <option [ngValue]="opt">
            {{ opt?.[optionKeyText] ?? (translationPrefix ?? '') + opt | translate }}
          </option>
        }
      </select>
    }
    @if (btnLabel?.length || btnIcon?.length) {
      <div class="input-group-btn">
        <btn [label]="btnLabel" [classes]="btnClasses" [icon]="btnIcon" (onEvent)="onBtnClick($event)"></btn>
      </div>
    }
    @if (requiredCssClass) {
      <div [ngClass]="{ 'invalid-feedback': requiredCssClass }" style="color: #f0142f" data-cy="error_msg">
        {{ errors | formError: formControlName | translate }}
      </div>
    }
  </div>
  @if (appendUnitEU) {
    <span class="input-group-unit"> EU </span>
  }
  @if (appendUnitUK) {
    <span class="input-group-unit"> UK </span>
  }
  @if (appendUnitUS) {
    <span class="input-group-unit"> US </span>
  }
  @if (appendUnitCm) {
    <span class="input-group-unit"> cm </span>
  }
</div>
